import React from "react";

const Contact = () => {
  const styles = {
    section: {
      padding: "2.5rem 0",
      background: "#fff",
      display: "flex",
      justifyContent: "center",
    },
    card: {
      width: "100%",
      maxWidth: "680px",
      padding: "1.5rem",
      borderRadius: "16px",
      background: "#ffffff",
      border: "1px solid #e5e7eb",
      boxShadow: "0 10px 25px rgba(0,0,0,0.06)",
    },
    title: {
      fontSize: "1.9rem",
      fontWeight: 700,
      marginBottom: "0.6rem",
      color: "#111827",
      textAlign: "center",
    },
    phone: {
      fontSize: "1.05rem",
      marginBottom: "1.5rem",
      color: "#116530",
      fontWeight: 600,
      textAlign: "center",
    },
    addressBox: {
      padding: "0.7rem 0",
      borderBottom: "1px solid #e5e7eb",
      color: "#6b7280",
      fontSize: "0.95rem",
      marginBottom: "1rem",
      textAlign: "center",
    },
  };

  return (
    <section id="contact" style={styles.section}>
      <div className="contact-card" style={styles.card}>
        <h2 style={styles.title}>Contact Us</h2>
        <div style={styles.addressBox}>
          43 RIICO Industrial Area, Salampura, Bhilwara, Rajasthan, 311001
        </div>
        <div style={styles.phone}>+919166610999, +919829044107</div>
      </div>
    </section>
  );
};

export default Contact;
